export enum ExampleEnum {
  Zero = 0,
  One,
}
export enum IncludeLastestEnum {
  GetNews = 0,
  IncludeLastest,
}

export enum TypeCallAPIEnum {
  Static = 'static',
  Dynamic = 'dynamic',
}

export enum DocumentTypeEnum {
  PrivacyPolicy = 'PRIVACY_POLICY',
  CloudServicesAgreement = 'CLOUD_SERVICES_AGREEMENT',
  TermsOfSservice = 'TERMS_OF_SERVICE',
  FinancialConflictOfInterestPolicy = 'Financial_Conflict_of_Interest_Policy'
  
}

export enum AppStoreURLEnum {
  AppStore = 'https://itunes.apple.com/us/app/apple-store/id1615008664?mt=8',
  GooglePlay = 'https://play.google.com/store/apps/details?id=com.bellepro.app',
}

export enum DetectOsEnum {
  Android = 'Android',
  MacOs = ' Mac OS',
  Windows = 'Windows',
  iOS = 'iOS',
}
